import type { PersonDataResponse } from '../../model';
import type { CurrentAddressFormValues } from '../../model/schemas';

export function recoverCurrentAddress(
  dto: PersonDataResponse
): Partial<CurrentAddressFormValues> {
  const location = dto?.currentAddress?.location;

  return {
    country: location?.country ?? '',
    region: location?.region ?? '',
    province: location?.province ?? '',
    cityOrMunicipality: location?.cityOrMunicipality ?? '',
    postalCode: location?.postalCode ?? '',
    barangay: location?.barangay ?? '',
    streetAndHouse: location?.streetAndHouse ?? '',
    unitAndFloor: location?.unitAndFloor ?? '',
  };
}
